/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const GetPersonalHealthRecordCsvResponseTypename = "GetPersonalHealthRecordCsvResponse" as const;

/**
 *
 * @export
 * @interface GetPersonalHealthRecordCsvResponse
 */
export interface GetPersonalHealthRecordCsvResponse {
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordCsvResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordCsvResponse
   */
  status: GetPersonalHealthRecordCsvResponseStatusEnum;
  /**
   *
   * @type {string}
   * @memberof GetPersonalHealthRecordCsvResponse
   */
  url?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof GetPersonalHealthRecordCsvResponse
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum GetPersonalHealthRecordCsvResponseStatusEnum {
  Initialized = "initialized",
  Processing = "processing",
  Generated = "generated",
  Failed = "failed",
  Nothing = "nothing",
}

export function GetPersonalHealthRecordCsvResponseFromJSON(json: any): GetPersonalHealthRecordCsvResponse {
  return GetPersonalHealthRecordCsvResponseFromJSONTyped(json, false);
}

export function GetPersonalHealthRecordCsvResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetPersonalHealthRecordCsvResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: GetPersonalHealthRecordCsvResponseTypename,

    id: !exists(json, "id") ? undefined : json["id"],
    status: json["status"],
    url: !exists(json, "url") ? undefined : json["url"],
  };
}

export function GetPersonalHealthRecordCsvResponseToJSON(object?: GetPersonalHealthRecordCsvResponse | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    id: value.id,
    status: value.status,
    url: value.url,
  };
}
